import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
// eslint-disable-next-line import/no-unresolved
import { initializeApp } from 'firebase/app';
// eslint-disable-next-line import/no-unresolved
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { FrameApi, SeoApi } from 'services';
import styled from 'styled-components';
import { UseMode } from '../../src/hooks/DarkModeHook';

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const game = context.query.game?.toString();

  const [seo, frameUrl] = await Promise.all([SeoApi.getGame(), FrameApi.getAll()]);

  return {
    props: {
      seo,
      frameUrl,
      ...(game && { game }),
    },
  };
}


const setThemeModeToFrame = (data: boolean) => {
  const msg_obj = {
    type: 'THEME',
    data: {theme: data ? 'dark' : 'light'},
  };

  const receiver = document.getElementById('myframe') as HTMLIFrameElement;
  receiver?.contentWindow?.postMessage(JSON.stringify(msg_obj), '*');
}

export default function News({
  seo,
  frameUrl: { frame_url },
  game,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const siteThemeValue = UseMode().value;
  const [themeMode, setThemeMode] = useState(undefined)
  useEffect(() => {
    if(themeMode !== siteThemeValue) {
      // @ts-ignore
      setThemeMode(siteThemeValue)
    }
  }, [siteThemeValue]);

  useEffect(() => {
    if(typeof themeMode === 'boolean') {
      // @ts-ignore
      setThemeModeToFrame(themeMode)
    }
  }, [themeMode])

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('./firebase-messaging-sw.js')
        .then(() => {
          // eslint-disable-next-line no-console
          console.log('Firebase Worker Registered');
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log('Service Worker registration failed: ', err);
        });
    }
  }, []);

  const copiedToClipboard = (event: { origin: string; data: any; }) => {
    if (event.origin == 'https://game.belbet.by') {
      if(event?.data.indexOf('referral')!== -1) {
        const recievedData = JSON.parse(event.data);
        if(recievedData?.reason == "referral") {
          navigator.clipboard.writeText(recievedData.message).then(() => {
            console.log("Message " + recievedData.message + " copied to the clipboard!");
          }).catch(err => {
            console.log('Something went wrong', err);
          });
        }
      }
      if(event.data.indexOf('promocode')!== -1) {
        navigator.clipboard.readText().then(data => {
          console.log('Clipboard content is: ', data);
          const frame = document?.querySelector('#myframe') as HTMLIFrameElement
          if(frame !== null && frame.contentWindow) {
            frame.contentWindow.postMessage(
              JSON.stringify({
                type: 'promo',
                data: data
              }), '*')
          }
        });
      }
      if(typeof event.data === 'string' && event.data.indexOf("unityIsReady") !== -1) {
        setThemeModeToFrame(siteThemeValue)
      }
    }
  }

  useEffect(() => {
    const eventMethod = 'addEventListener';
    const eventer = window[eventMethod];
    const messageEvent = 'message';

    eventer(messageEvent, (e: any) => {
      if (e.data === 'handshake done' || e.message === 'handshake done') {
        // eslint-disable-next-line no-console
        console.log('[Main] Connected to iFrame successfully');
      }

      if (e.data === 'readyForMessaging' || e.message === 'readyForMessaging') {
        runRealFirebaseScript();
      }
    });

    const iframe = document.getElementById('myframe');

    if (iframe) {
      iframe.onload = runFirebaseScript;
    }

    window.addEventListener("message", copiedToClipboard);

    return () => {
      window.removeEventListener('message', copiedToClipboard)
    }
  }, []);

  return (
    <>
      <Head>
        <title>{seo[0]?.title ?? 'belbet'}</title>
        <meta name="description" content={seo[0]?.description} />
      </Head>

      <GameContainer>
        <IframeWrapper>
          <GameIframe
            id="myframe"
            title="gameIframe"
            src={`${frame_url}${game ? `?game=${game}` : ''}`}
            frameBorder="0"
          />
        </IframeWrapper>
      </GameContainer>
    </>
  );
}

const GameContainer = styled.div`
  padding-bottom: 60px;
`;

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56.25%;
  border-radius: 30px;
  overflow: hidden;
`;

const GameIframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 26px;
`;

function runFirebaseScript() {
  const msg_obj = {
    msg_type: 'handshake',
    msg_data: 'test connection from Main to iFrame',
  };

  sendToIFrame(msg_obj);
}

function sendTokenToIFrame(token: string) {
  const msg_obj = {
    msg_type: 'token',
    msg_data: token,
  };

  sendToIFrame(msg_obj);
}

function sendToIFrame(data: any) {
  const receiver = document.getElementById('myframe') as HTMLIFrameElement;
  receiver?.contentWindow?.postMessage(JSON.stringify(data), '*');
}

function sendMessageToIFrame(msg: any) {
  const msg_obj = {
    msg_type: 'message',
    msg_data: msg,
  };
  sendToIFrame(msg_obj);
}

function runRealFirebaseScript() {
  const config = {
    apiKey: 'AIzaSyCw8fQcxzLpPFnb9jVrQdOmJq_ftmcjFfg',
    authDomain: 'bb-firebase-prod.firebaseapp.com',
    databaseURL: 'https://bb-firebase-prod-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'bb-firebase-prod',
    storageBucket: 'bb-firebase-prod.appspot.com',
    messagingSenderId: '390252138709',
    appId: '1:390252138709:web:0eafded8e731cb1859125c',
    measurementId: 'G-85EQGWK4J4',
  };

  const fapp = initializeApp(config);
  const messaging = getMessaging(fapp);

  getToken(messaging, {
    vapidKey: 'BEJITsQynR5p76qH58ObKt0glBN4Ts0jk9fiAPdpHYdxFRBhz6Rbwqkdc4eZhihMhcvoRycQ4PoflAFcdCsitD4',
  })
    .then((currentToken) => {
      if (currentToken) {
        sendTokenToIFrame(currentToken);
      } else {
        // eslint-disable-next-line no-console
        console.log('[Firebase] No Instance ID token available.');
      }
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.log('[Firebase] An error occurred while retrieving token. ', err);
    });

  onMessage(messaging, (payload) => {
    if ('notification' in payload) {
      // eslint-disable-next-line no-console
      console.log('[Firebase]  OnMessage - push received, it is not our work - skipped)');
    } else {
      sendMessageToIFrame(payload);
    }
  });
}
